import { Box } from "@mui/material";
import { motion } from "framer-motion";
import type { ReactNode } from "react";
import React from "react";

import MotionContainer from "components/MotionContainer";
import { varBounceIn } from "components/MotionContainer/variants/bounceIn";
import Logo from "components/shared/Logo";
import Page from "components/shared/Page";
import { Typography } from "components/shared/Typography";

import ExternalPageFooter from "../ExternalPageFooter";
import { useStyles } from "./styles";

interface IExternalPageCardProps {
  pageTitle: string;
  headerTitle?: string;
  children: ReactNode;
  dataCy?: string;
}

const ExternalPageCard: React.FC<IExternalPageCardProps> = ({ pageTitle, headerTitle, children, dataCy }) => {
  const { classes } = useStyles();

  return (
    <Page
      title={pageTitle}
      className={classes.page}
      data-cy={dataCy}
    >
      <Box className={classes.card}>
        {headerTitle ? (
          <Box className={classes.header}>
            <Logo
              variant="mini"
              imgHeight={48}
              imgWidth={51}
              objectFit="contain"
              sx={{ marginBottom: 0.5 }}
            />
            <Typography
              component="div"
              className={classes.headerTitle}
            >
              {headerTitle}
            </Typography>
          </Box>
        ) : null}

        <MotionContainer
          initial="initial"
          open
        >
          <motion.div variants={varBounceIn}>
            <Box className={classes.body}>{children}</Box>
          </motion.div>
        </MotionContainer>

        <ExternalPageFooter />
      </Box>
    </Page>
  );
};

export default ExternalPageCard;
